import "./styles.scss"

import React from "react"

const PartnerModal = ({ image, title, descriptions, onClose }) => {
  return (
    <div className="partner-modal">
      <div
        className={`partner-modal__dialog${
          !image ? " partner-modal__dialog--shrink" : ""
        }`}
      >
        <div className="partner-modal__content">
          <button className="partner-modal__close" onClick={onClose}>
            Close
          </button>
          {image && (
            <div className="partner-modal__image">
              <img src={image} alt="" />
            </div>
          )}
          <div className="partner-modal__description">
            {title && <h3>{title}</h3>}
            {descriptions?.length > 0 &&
              descriptions.map((description, index) => (
                <div className="partner-modal__description-row" key={index}>
                  <h4>{description.title}:</h4>
                  <div
                    dangerouslySetInnerHTML={{ __html: description.content }}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnerModal
